import { TagSortOrder } from '@mnd-frontend/graphql-schema';
import { useMediaQuery } from '@mnd-frontend/hooks';
import { media } from '@mnd-frontend/ui/publish/utils';
import { useTranslation } from 'react-i18next';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

type Props = {
  totalCount: number;
  selectedIds: string[];
  searchQuery: string;
  pressroomId: string;
  selectedSort: TagSortOrder;
  onCombineClick: () => void;
  onDeleteClick: () => void;
  onSelectedIdsChanged: (ids: string[]) => void;
  onSearchQueryChanged: (query: string) => void;
  onSelectedSortChanged: (sort: TagSortOrder) => void;
};

const TagDataTableHeader = (props: Props) => {
  const [t] = useTranslation();
  const isSmall = useMediaQuery(media.lessThan('phablet'));
  const sortOptions = [
    {
      label: t('category_management_sort_name'),
      value: TagSortOrder.Name,
    },
    {
      label: t('category_management_sort_count'),
      value: TagSortOrder.Count,
    },
  ];

  return (
    <>
      {isSmall ? (
        <MobileHeader {...props} />
      ) : (
        <DesktopHeader {...props} sortOptions={sortOptions} />
      )}
    </>
  );
};

export default TagDataTableHeader;
